import { useQuery } from "@tanstack/react-query";
import {
  getHomeworkDetails,
  getSharedHomeworkDetails,
} from "../../../api/endpoints/HomeworkEndpoints";

export default function useGetHomeworkDetails(
  homeworkId: string,
  isShared = false,
) {
  return useQuery({
    queryKey: ["homework", homeworkId, isShared],
    queryFn: isShared
      ? () => getSharedHomeworkDetails(homeworkId)
      : () => getHomeworkDetails(homeworkId),
  });
}
